module.exports = __webpack_public_path__ + "img/lavender-logo.6c5931f1.jpg";